/**
 * @desc 发运信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CabinFactoryDeliveryRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryWhole/delivery`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
